import apis from ".";

export async function addProduct(product, token) {
  try {
    const result = await apis.post("/product/add-product", product, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export async function updateProduct(product, token) {
  try {
    const result = await apis.post("/product/update-product", product, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export async function getProducts(data, token) {
  try {
    const result = await apis.get(
      `/product/get-all-products-by-seller-id?sellerId=${
        data.sellerId
      }&perPage=${data.perPage}&page=${data.page + 1}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export async function getCategories(level, token) {
  try {
    const result = await apis.get(
      `/category/get-categories-by-level?page=1&perPage=5&level=${level}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export async function getMetadataProducts(categoriesID, token) {
  try {
    const result = await apis.get(
      `/category/get-metadata-by-category?page=1&perPage=5&categoryId=${categoriesID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export async function disableProduct(productId, token) {
  try {
    const result = await apis.post(
      `/product/disable-product`,
      {
        id: productId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}
